import { matchAdjacentPairs } from "../matching"
import type { Edge2dComputed, Node2d } from "../mesh"

export const nodesToEdges = (nodes: Node2d[]): Edge2dComputed[] =>
  matchAdjacentPairs(nodes, (nodeA, nodeB) => ({
    p1: nodeA,
    p2: nodeB,
  }))
